<template>
    <b-form v-if="member && member.dependents">
        <b-row>
            <b-col md="10">
                <b-alert class="card-text" variant="warning" show>
                    Please include all covered dependents. Removed dependents will be
                    terminated.
                </b-alert>
            </b-col>
        </b-row>
        <br>
        <b-row>
            <b-col md="10"
                   v-if="member.dependents.length===0">
                <b-button @click="addChild()">Add Child</b-button>
            </b-col>
        </b-row>
        <b-row v-for="(child, index) in member.dependents" :key="index">
            <b-col md="10">
                <b-form-group label="Dependent First Name:" label-cols-md="6">
                    <b-form-input
                            type="text"
                            v-model="child.firstName"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Dependent Last Name:" label-cols-md="6">
                    <b-form-input
                            type="text"
                            v-model="child.lastName"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Dependent Middle Initial:" label-cols-md="6">
                    <b-form-input
                            type="text"
                            v-model="child.middleInitial"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Dependent DOB:" label-cols-md="6">
                    <b-form-input
                            type="date"
                            v-model="child.dob"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Dependent Gender:" label-cols-md="6">
                    <b-form-select
                            id="gender"
                            type="text"
                            v-model="child.gender"
                            :options="genderOptions">
                    </b-form-select>
                </b-form-group>
                <b-form-group label="Dependent Relationship:" label-cols-md="6">
                    <b-form-radio-group :options="dependentOptions" v-model="child.type"
                                        label-cols-md="6">
                    </b-form-radio-group>
                </b-form-group>
                <b-form-group label="Dependent Other Coverage:" label-cols-md="6">
                    <b-form-radio-group :options="otherCoverageOptions" v-model="child.cov"
                                        label-cols-md="6">
                    </b-form-radio-group>
                    <b-form-input
                            id="other_carrier"
                            type="text"
                            placeholder="Enter the carrier's name"
                            v-model="child.otherCarrier"
                            v-show="child.cov === 'Y'">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="2">
                <b-button
                        @click="addChild()"
                        v-if="(index === member.dependents.length-1)">
                    Add Child
                </b-button>
                <b-button @click="removeChild(index)" v-if="member.dependents.length > 1">
                    Remove
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="10">
                <b-button @click="saveUpdate()">Save Dependents</b-button>
                <b-button variant="outline" @click="$router.go(-1)">Cancel</b-button>
            </b-col>
        </b-row>
    </b-form>
    <div style="padding-bottom: 200px" v-else>
        <b-spinner small></b-spinner>&nbsp;Loading member...
    </div>
</template>

<script>
    import axios from "axios";
    import config from '@/config/config'

    export default {
        name: 'Dependents',
        props: ['member'],
        data: function () {
            return {
                otherCoverageOptions: [
                    {value: 'Y', text: 'Yes'},
                    {value: 'N', text: 'No Other Coverage'}
                ],
                genderOptions: [
                    {value: '', text: 'Please Select'},
                    {value: 'F', text: 'Female'},
                    {value: 'M', text: 'Male'}
                ],
                dependentOptions: [
                    {value: 'spouse', text: 'Spouse'},
                    {value: 'child', text: 'Child'}
                ],
            }
        },
        methods: {
            addChild: function () {
                this.member.dependents.push({})
            },
            removeChild: function (index) {
                this.member.dependents.splice(index, 1)
            },
            saveUpdate: function() {
                let payload = {
                    cert: this.member.cert,
                    groupCode: this.member.underwriter + this.member.group,
                    changeRequested: this.member
                };

                axios.post(config.apiUrl() + 'member/dependents/' + this.member.cert, payload).then(response => {
                    if (response.data.msg === 'ok') {
                        this.$router.go(-1);
                    } else {
                        console.error('error in request');
                        this.$router.go(-1);
                    }
                }, err => {
                    console.error('error in request');
                    this.$router.go(-1);
                })
            }
        }
    }
</script>

<style scoped>

</style>
